export interface IKycStakeholderInfo {
  name?: string;
  shareholding?: number | string;
  gender?: string;
  birthdate?: string;
  nationality?: string;
  email?: string;
  phone?: string;
  documentCheckStatus?: string;
  documentFailureReason?: string;
  faceCheckStatus?: string;
  faceFailureReason?: string;
}

// KYC个人信息展示key枚举（不包括问卷数据）
export const KYC_INDIVIDUALS_DISPLAY_KEYS = [
  "name",
  "age",
  "gender",
  "birthday",
  "countryCode",
  "nationality",
  "passportId",
  "contactAddress",
  "phone",
  "email",
  // 旧kyc问卷，只用作旧数据显示
  "annualIncome",
  "sourceOfIncome",
  "sourceOfFund",
  "liquidAssets",
  "totalAssets",
];

// KYC个人信息 每个key对应label的文案
export const KYC_INDIVIDUALS_LABEL_TEXT = {
  name: "kyc.individual.fullname",
  birthday: "kyc.individual.birth",
  age: "kyc.individual.age",
  gender: "kyc.individual.gender",
  nationality: "kyc.individual.nationality",
  passportId: "kyc.individual.cardId",
  phone: "kyc.certify.institutions.authorizedPhone",
  email: "kyc.individual.email",
  contactAddress: "kyc.individual.address",
  // 旧问卷数据仅作展示
  annualIncome: "kyc.certify.old.data.individual.label.annualIncome",
  sourceOfIncome: "kyc.certify.old.data.individual.label.sourceOfIncome",
  sourceOfFund: "kyc.certify.old.data.individual.label.sourceOfFund",
  liquidAssets: "kyc.certify.old.data.individual.label.liquidAssets",
  totalAssets: "kyc.certify.old.data.individual.label.totalAssets",
};

// KYC机构信息展示key枚举（不包括问卷数据）
export const KYC_INSTITUTIONS_DISPLAY_KEYS = [
  "name",
  "businessNature",
  "brNumber",
  "companyRegistrationCountry",
  "contactAddress",
  "companyType",
  "directorName",
  "directorShareholding",
  "directorEmail",
  "directorNationality",
  "directorGender",
  "directorBirthdate",
  "directorPhone",
  "beneficiaryName",
  "beneficiaryShareholding",
  "beneficiaryEmail",
  "beneficiaryNationality",
  "beneficiaryGender",
  "beneficiaryBirthdate",
  "beneficiaryPhone",

  // 旧kyc问卷
  "sourceOfFund",
  "liquidAssets",
  "totalAssets",
];

// KYC机构信息 每个key对应label的文案
export const KYC_INSTITUTIONS_LABEL_TEXT = {
  director: "kyc.certify.institutions.director",
  beneficiary: "kyc.certify.institutions.director",
  name: "kyc.certify.institutions.name",
  businessNature: "kyc.certify.institutions.business.nature",
  brNumber: "kyc.certify.institutions.taxIdentificationNumber",
  companyRegistrationCountry: "kyc.certify.institutions.CountryIncorporation",
  contactAddress: "kyc.certify.institutions.address",
  companyType: "kyc.certify.institutions.entity.type",
  directorName: "kyc.certify.institutions.directorName",
  directorShareholding: "kyc.certify.institutions.directorShareholding",
  directorEmail: "kyc.certify.institutions.directorEmail",
  directorNationality: "kyc.certify.institutions.directorNationality",
  directorGender: "kyc.certify.institutions.directorGender",
  directorBirthdate: "kyc.certify.institutions.directorBirthdate",
  directorPhone: "kyc.certify.institutions.directorPhone",
  beneficiaryName: "kyc.certify.institutions.beneficiaryName",
  beneficiaryShareholding: "kyc.certify.institutions.beneficiaryShareholding",
  beneficiaryEmail: "kyc.certify.institutions.beneficiaryEmail",
  beneficiaryNationality: "kyc.certify.institutions.beneficiaryNationality",
  beneficiaryGender: "kyc.certify.institutions.beneficiaryGender",
  beneficiaryBirthdate: "kyc.certify.institutions.beneficiaryBirthdate",
  beneficiaryPhone: "kyc.certify.institutions.beneficiaryPhone",
  ownershipPercentage: "kyc.certify.institutions.ownershipPercentage",
  phone: "kyc.certify.institutions.authorizedPhone",
  email: "kyc.certify.institutions.authorizedEmail",
  // 旧问卷数据仅作展示
  sourceOfFund: "kyc.certify.old.data.institutions.label.sourceOfFund",
  liquidAssets: "kyc.certify.old.data.institutions.label.liquidAssets",
  totalAssets: "kyc.certify.old.data.institutions.label.totalAssets",
};
